/**
 * Helpers de texto compartidos (NER-4488).
 */

/** Minúsculas y sin acentos, para comparar nombres de categorías, grupos, etc. */
export function normalizeText(value) {
  return (value || '')
    .toString()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}

/**
 * Devuelve `true` si el nombre de alguna de las `categories` contiene alguna
 * de las `hints` (comparación sin acentos ni mayúsculas).
 */
export function nameMatchesHints(name, hints) {
  const normalized = normalizeText(name);
  return (hints || []).some((hint) => {
    const needle = normalizeText(hint).trim();
    return needle.length > 0 && normalized.includes(needle);
  });
}
